// @flow

import { FilterClearButton, FilterExpandableFooter } from '@riseart/filter';
import { FilterItemBuilder } from 'shared_components/common/filters/item/Builder';
import { FilterSearchLink } from 'shared_components/common/filters/components/Search';

// CLEAR_BUTTON_TYPE
export const CLEAR_BUTTON_TYPE = {
  type: FilterClearButton,
  bindOwnProps: ({ totalActiveFilters, resetUrl = '/', formatMessage }: Object) => ({
    url: resetUrl,
    totalActiveFilters,
    displayAsButton: true,
    size: 'small',
    children: formatMessage({ id: 'components.filters.clearFilters' }),
  }),
  skipRenderer: ({ totalActiveFilters }: Object) => !totalActiveFilters,
};

// CLEAR_LINK_TYPE
export const CLEAR_LINK_TYPE = {
  type: FilterClearButton,
  bindOwnProps: ({ totalActiveFilters, resetUrl = '/', formatMessage }: Object) => {
    return {
      url: resetUrl,
      totalActiveFilters,
      children: formatMessage({ id: 'components.filters.clearAll' }),
    };
  },
  skipRenderer: ({ totalActiveFilters }: Object) => !totalActiveFilters,
};

// FILTER_ITEM_TYPE
export const FILTER_ITEM_TYPE = { type: FilterItemBuilder, bindOwnProps: (props: Object) => props };

// FILTER_EXPANDABLE_FOOTER_TYPE
export const FILTER_EXPANDABLE_FOOTER_TYPE = {
  type: FilterExpandableFooter,
  bindOwnProps: ({ formatMessage }: Object) => {
    return {
      titleShowMore: formatMessage({ id: 'components.filters.showMore' }),
      titleShowLess: formatMessage({ id: 'components.filters.showLess' }),
    };
  },
};

export const SEARCH_LINK = {
  type: FilterSearchLink,
  bindOwnProps: ({ formatMessage }: Object) => ({
    title: formatMessage({ id: 'forms.searchForm.submit' }),
    obfuscate: true,
  }),
};
